import { StringProperty, IStringProperty } from "./StringProperty";

export interface IUrlProperty extends IStringProperty {
  fixedPrefix?: string;
  fixedSuffix?: string;
}

export class UrlProperty extends StringProperty {
  public fixedPrefix: string = "";
  public fixedSuffix: string = "";

  constructor(opts: any, model?: any) {
    super(opts, model);

    if (typeof opts.fixedPrefix !== "undefined")
      this.fixedPrefix = opts.fixedPrefix;
    if (typeof opts.fixedSuffix !== "undefined")
      this.fixedSuffix = opts.fixedSuffix;

    // add url validation rule if not already present
    // if (this.rules.indexOf("url") === -1) {
    //   this.rules.push("url");
    // }
  }

  public get stringValue() {
    let val = super.stringValue;
    if (!val) return val;

    if (this.fixedPrefix && val && !val.startsWith(this.fixedPrefix)) {
      val = this.fixedPrefix + val;
    }
    if (this.fixedSuffix && val && !val.endsWith(this.fixedSuffix)) {
      val = val + this.fixedSuffix;
    }
    return val;
  }
}
